import type {ThemeVariablesType} from "../../variables";
import {SpacialFn, NormalizedMarginProp, UnnormalizedMarginProp} from "@yosmanyga/core-style";

const normalizeMargin = (
    margin: UnnormalizedMarginProp | undefined,
    theme: {variables: ThemeVariablesType}
): NormalizedMarginProp | undefined => {
    margin = SpacialFn.normalizeMargin(margin);

    if (
        !margin
        || typeof margin !== 'object'
        || margin['raw'] == true
    ) {
        return margin;
    }

    if (margin.top) {
        margin.top = theme.variables.spacing(margin.top)
    }

    if (margin.bottom) {
        margin.bottom = theme.variables.spacing(margin.bottom)
    }

    if (margin.left) {
        margin.left = theme.variables.spacing(margin.left)
    }

    if (margin.right) {
        margin.right = theme.variables.spacing(margin.right)
    }

    return margin;
}

export {
    normalizeMargin
}